module.exports = __webpack_public_path__ + "static/img/location.b9188660.png";